/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Steps } from "antd";
import "./sidebar.css"; // Import the CSS file

interface SidebarProps {
  nextSteps?: number;
  offlineFlow: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ nextSteps, offlineFlow }) => {
  const [current, setCurrent] = useState(nextSteps);

  useEffect(() => {
    setCurrent(nextSteps);
  }, [nextSteps]);

  const adobeDTSSteps = [
    { title: "DTS Agreement" },
    { title: "Supplier Signature" },
    { title: "Requester Signature" },
    { title: "Data Upload" },
    { title: "Review" },
  ];

  const offlineDTSSteps = [
    { title: "DTS Agreement" },
    { title: "Upload Offline DTS" },
    { title: "Data Upload" },
    { title: "Review" },
  ];

  return (
    <Steps
      direction="vertical"
      size="small"
      current={current}
      className="vertical-step"
      items={offlineFlow ? offlineDTSSteps : adobeDTSSteps}
    />
  );
};

export default Sidebar;
